import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { AdBannerMicrofrontendContainer } from '../AdBannerMicrofrontendContainer';
import { useSeoTopParameters } from './hooks/useSeoTopParameters';

interface IAdBannerMicrofrontendSeoTopContainerProps {
  manifest: IMicrofrontendManifest;
  onStub?: () => void;
  onError?: () => void;
  onClose?: () => void;
}

/**
 * Place-контейнер SEO-баннера в футере: поставляет параметры места и рендерит generic-контейнер.
 */
export const AdBannerMicrofrontendSeoTopContainer: React.FC<IAdBannerMicrofrontendSeoTopContainerProps> = ({
  manifest,
  onStub,
  onError,
  onClose,
}) => {
  const parameters = useSeoTopParameters();

  return (
    <AdBannerMicrofrontendContainer
      manifest={manifest}
      parameters={parameters}
      onStub={onStub}
      onError={onError}
      onClose={onClose}
    />
  );
};
